
namespace RioERP.Masters {
    export class PendriveTypesColumns {
        static columnsKey = 'Masters.PendriveTypes';
    }
}